export default {
  notes: 'Notes',
  createNote: 'Create note',
  addNote: 'Add note',
  editNote: 'Edit note',
  text: 'Text',
  empty: 'There are no created notes yet.',
};
